import styled from "styled-components";
import { ButtonPrimaryInternal } from "../Primary";
import { ButtonHoC } from "../button.js";
export const ButtonSecondaryReverseInternal = styled(ButtonPrimaryInternal)`
  background-color: ${props => props.theme.colors.action};
  border: 2px solid #ffffff;
  line-height: 20px;

  &:hover,
  &:focus {
    background-color: #ffffff;
    color: ${props => props.theme.colors.action};
  }
  & > div {
    height: 20px;
  }
`;
export const ButtonSecondaryReverse = ButtonHoC(ButtonSecondaryReverseInternal);
export const ButtonSecondaryReverseSmallInternal = styled(ButtonSecondaryReverseInternal)`min-width: 84px;`;
export const ButtonSecondaryReverseSmall = ButtonHoC(ButtonSecondaryReverseSmallInternal);